


import React, { useState, useEffect } from "react";
import {Box, Paper, Grid, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, Button, Stack, IconButton, } from '@mui/material';
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { DataGrid } from "@mui/x-data-grid";
import PageLoader from "../../../components/Loader/PageLoader"
import DeleteIcon from '@mui/icons-material/Delete';
import HeaderName from "../../../components/Custom/HeaderName";
 import {getPickupAllocated} from "../../../redux/Thunk/officePickupThunk";
import EditIcon from "../../../components/Icons/EditIcon";
import { getDrsList,deleteDrsDetails } from "../../../redux/Thunk/drsThunk";
import Swal from "sweetalert2";
import { useSelector } from 'react-redux';
import AllocateDialog from "../../../components/Dialogbox/AllocateDialog";
import moment from "moment";
const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return debouncedValue;
};


const PickupAllocated =() =>{
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [loader, setLoader] = useState(false)
  const [totalCount, setTotalCount] = useState(0)
  const role = localStorage.getItem('role');
  const [selectedRows, setSelectedRows] = useState([]);
  const [search,setSearch] = useState('');
  const [drsList, setDrsList] = useState([])
    const debouncedSearch = useDebounce(search, 500);
  const [page, setPage] = useState({
    page:0,
    pageSize:10
  })

  const officeId = useSelector((state) => state.auth.officeId);
  
  useEffect(()=>{
fetchAllocated()
  },[page ,debouncedSearch])

  // get allPickup details
const fetchAllocated = async () => {
  setLoader(true); 
  dispatch(getPickupAllocated({page:page+1,limit:page.pageSize, search: debouncedSearch, OfficeId: officeId, isAllocated:"true"})) // API call
    .then((res) => {
      const data = res?.payload?.data; 
      setDrsList(data); 
      setTotalCount(res?.payload?.total); 
      setLoader(false);
    });
};


  const handleRowSelection = (selection) => {
    if (selection?.length === 0) {
      // If no rows selected, clear the selected rows
      setSelectedRows([]);
    } else {
     
      setSelectedRows(selectedRows);
    }
  };



  const columns = [
  {
    flex: 0.1,
    minWidth: 60,
    field: 'Sr.No',
    align: 'center',
    headerName: 'Sr. No',
    renderCell: params => (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%' }}>
        <Typography noWrap variant='body2'>
          {page?.page * page?.pageSize + params.api.getAllRowIds().indexOf(params.id) + 1}
        </Typography>
      </Box>
    )
  },
  {
    flex: 0.35,
    minWidth: 120,
    field: 'RequestedId',
    headerName: 'Id',
    align: 'center',
    renderCell: params => (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%' }}>
        <Typography noWrap variant='body2' sx={{ textAlign: 'center', maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-word', flex: 1 }}>
          {params.row?.RequestedId || '--'}
        </Typography>
      </Box>
    )
  },
  {
    flex: 0.25,
    minWidth: 120,
    field: 'officeName',
    headerName: 'Office Name',
    align: 'center',
    renderCell: params => {
      const officeName = params.row?.OfficeDetails?.[0]?.OfficeName || '--'
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%' }}>
          <Typography noWrap variant='body2' sx={{ textAlign: 'center', maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-word', flex: 1 }}>
            {officeName}
          </Typography>
        </Box>
      )
    }
  },
  {
    flex: 0.25,
    minWidth: 150,
    field: 'Date',
    headerName: 'Allocate Date & Time',
    align: 'center',
    renderCell: ({ row }) => {
        return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%' }}>
            <Typography noWrap variant='body2'>
             {moment(row?.createdAt).format('D/M/YYYY, h:mm A')}
            </Typography>
          </Box>
  
    )}
  },
  {
    flex: 0.4,
    minWidth: 130,
    field: 'CustomerName',
    headerName: 'Customer Name',
    align: 'center',
    renderCell: params => {
      const customerName = params.row?.Customers?.[0]?.CustomerName || '--'
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%' }}>
          <Typography noWrap variant='body2' sx={{ textAlign: 'center', maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-word', flex: 1 }}>
            {customerName}
          </Typography>
        </Box>
      )
    }
  },
  {
    flex: 0.55,
    minWidth: 110,
    field: 'Origin',
    headerName: 'Origin',
    align: 'center',
    renderCell: params => (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%' }}>
        <Typography noWrap variant='body2' sx={{ textAlign: 'center', maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-word', flex: 1 }}>
          {params.row?.Origin || '--'}
        </Typography>
      </Box>
    )
  },
  {
    flex: 0.35,
    minWidth: 120,
    field: 'Destination',
    headerName: 'Destination',
    align: 'center',
    renderCell: params => (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%' }}>
        <Typography noWrap variant='body2' sx={{ textAlign: 'center', maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-word', flex: 1 }}>
          {params.row?.Destination || '--'}
        </Typography>
      </Box>
    )
  },
  {
    flex: 0.5,
    minWidth: 110,
    field: 'Deliveryboy',
    headerName: 'Delivery boy',
    align: 'center',
    renderCell: params => (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%' }}>
        <Typography noWrap variant='body2' sx={{ textAlign: 'center', maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-word', flex: 1 }}>
          {params.row?.DeliveryBoyDetails?.[0]?.DeliveryBoyName || '--'}
        </Typography>
      </Box>
    )
  },
 
  {
    flex: 0.5,
    minWidth: 110,
    field: ' Status',
    headerName: 'Status',
    align: 'center',
    renderCell: params => {
      const isAllocated = params.row.isAllocated === true
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%' }}>
          <Typography noWrap variant='body2' sx={{ textAlign: 'center', maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-word' }}>
            {isAllocated ? 'Allocated' : 'Pending'}
          </Typography>
        </Box>
      )
    }
  },
   {
    flex: 0.5,
    minWidth: 110,
    field: 'Remark',
    headerName: 'Remarks',
    align: 'center',
    renderCell: params => (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%' }}>
        <Typography noWrap variant='body2' sx={{ textAlign: 'center', maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-word', flex: 1 }}>
          {params.row?.Remark || '--'}
        </Typography>
      </Box>
    )
  },
  {
    field: 'action',
    headerName: 'Action',
    width: 150,
    sortable: false,
    renderCell: params => {
      const isAllocated = params.row.isAllocated === true
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%' }}>
          <Button variant="contained" size="small" color={isAllocated ? 'success' : 'error'}>
            {isAllocated ? 'Allocated' : 'Deallocated'}
          </Button>
        </Box>
      )
    }
  }
]


    return(
        <>
          <div style={{display:'flex', flexDirection:'column', flexGrow: 1,overflowX:"auto"}}>
            {/* <Header /> */}
            { loader ? <PageLoader /> : 
              <Grid container style={{padding:'0px 0px', display:'flex', flexDirection:'row', justifyContent:'space-between',width:"94%"}}>   
                <Grid size={{ xs: 12, sm: 12, md: 12, lg:12 }}>
                  <HeaderName headerName={'Pickup Allocated List'} displaySearch = {true} newForm = {false} onClickBackButton={()=> navigate("/dashboard")} setSearch ={setSearch} search={search}/>
                  <div className="custom-data-grid-container_table">
                    <DataGrid
                      sx={{
                        borderRadius: "31px",
                        overflowY: "auto",
                      }}
                      style={{ width: '100%' }}
                      pagination
                      // checkboxSelection
                      rows={drsList}
                      rowHeight={55}
                      rowCount={totalCount}
                      getRowId={param=> param._id}
                      columns={columns}
                      paginationModel={page}
                      sortingMode='server'
                      paginationMode='server'
                      pageSizeOptions={[10, 50, 100]}
                      onPaginationModelChange={(newPage)=>setPage(newPage)}
                      className="custom-data-grid"
                      selectionModel={selectedRows ? [selectedRows] : []}
                      onRowSelectionModelChange={handleRowSelection}
                      initialState={{
                        totalCount,
                        pagination: { paginationModel: {page:1, pageSize: 10}},
                      }}
                      disableRowSelectionOnClick
                      disableColumnMenu
                      disableColumnFilter
                      disableColumnSorting
                    />
                  </div>
                </Grid>
              </Grid>
            }
          </div>
        

        </>
    )
}

export default PickupAllocated



